{
  "showMore": { "whenCollapsed": "Show more", "whenExpanded": "Show less" }
}
